// src/pages/GDPR.tsx
import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from '@/components/ui/separator';
import { ScrollArea } from '@/components/ui/scroll-area';

const GDPR = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-lg shadow-md p-8 border border-gray-100"
          >
            <h1 className="text-3xl font-bold text-stone-800 mb-6">GDPR - Politika varstva osebnih podatkov</h1>
            <Separator className="mb-6" />
            
            <ScrollArea className="h-[70vh] pr-4">
              <div className="space-y-6">
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Uvod</h2>
                  <p className="text-stone-600 mb-3">
                    Pri podjetju Kamen d.o.o. cenimo vašo zasebnost in smo zavezani k varovanju vaših osebnih podatkov. 
                    Ta politika varstva podatkov pojasnjuje, kako zbiramo, uporabljamo, obdelujemo in varujemo vaše osebne podatke 
                    v skladu s Splošno uredbo o varstvu podatkov (GDPR) in drugimi relevantnimi zakonodajami o varstvu podatkov.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Vrste podatkov, ki jih zbiramo</h2>
                  <p className="text-stone-600 mb-3">
                    Zbiramo lahko naslednje vrste osebnih podatkov:
                  </p>
                  <ul className="list-disc pl-6 text-stone-600 space-y-2">
                    <li>Osebni kontaktni podatki (ime, priimek, e-poštni naslov, telefonska številka, naslov)</li>
                    <li>Podatki o naročilih in transakcijah</li>
                    <li>Tehnični podatki (IP naslov, podatki o brskalniku, lokacija)</li>
                    <li>Podatki o uporabi spletne strani</li>
                    <li>Marketinške preference</li>
                  </ul>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Kako uporabljamo vaše podatke</h2>
                  <p className="text-stone-600 mb-3">
                    Vaše osebne podatke uporabljamo za naslednje namene:
                  </p>
                  <ul className="list-disc pl-6 text-stone-600 space-y-2">
                    <li>Za obdelavo in dostavo vaših naročil</li>
                    <li>Za zagotavljanje podpore strankam</li>
                    <li>Za izboljšanje našega spletnega mesta in storitev</li>
                    <li>Za pošiljanje relevantnih marketinških sporočil (če ste se strinjali s prejemanjem)</li>
                    <li>Za izpolnjevanje zakonskih obveznosti</li>
                  </ul>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Pravna podlaga za obdelavo</h2>
                  <p className="text-stone-600 mb-3">
                    Vaše osebne podatke obdelujemo na naslednjih pravnih podlagah:
                  </p>
                  <ul className="list-disc pl-6 text-stone-600 space-y-2">
                    <li><span className="font-medium">Izvedba pogodbe:</span> Za obdelavo naročil in zagotavljanje storitev.</li>
                    <li><span className="font-medium">Zakoniti interes:</span> Za izboljšanje naših storitev in za marketinške namene.</li>
                    <li><span className="font-medium">Soglasje:</span> Za pošiljanje promocijskih materialov in drugih komunikacij.</li>
                    <li><span className="font-medium">Zakonska obveznost:</span> Za izpolnjevanje naših zakonskih obveznosti.</li>
                  </ul>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Hramba podatkov</h2>
                  <p className="text-stone-600 mb-3">
                    Vaše osebne podatke hranimo samo toliko časa, kolikor je potrebno za izpolnitev namenov, za katere smo jih zbrali, 
                    vključno z izpolnitvijo zakonskih, računovodskih ali poročevalskih zahtev.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Vaše pravice</h2>
                  <p className="text-stone-600 mb-3">
                    V skladu z GDPR imate naslednje pravice:
                  </p>
                  <ul className="list-disc pl-6 text-stone-600 space-y-2">
                    <li>Pravica do dostopa do vaših osebnih podatkov</li>
                    <li>Pravica do popravka netočnih podatkov</li>
                    <li>Pravica do izbrisa podatkov ("pravica do pozabe")</li>
                    <li>Pravica do omejitve obdelave</li>
                    <li>Pravica do prenosljivosti podatkov</li>
                    <li>Pravica do ugovora</li>
                    <li>Pravica do umika soglasja</li>
                  </ul>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Varnost podatkov</h2>
                  <p className="text-stone-600 mb-3">
                    Uporabljamo ustrezne tehnične in organizacijske ukrepe za zaščito vaših osebnih podatkov pred nepooblaščenim 
                    dostopom, izgubo ali krajo. Naši zaposleni, ki imajo dostop do vaših podatkov, so zavezani k spoštovanju zaupnosti.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Spremembe politike varstva podatkov</h2>
                  <p className="text-stone-600 mb-3">
                    To politiko varstva podatkov lahko občasno posodobimo. Vse spremembe bodo objavljene na tej strani. 
                    Če bodo spremembe pomembne, vas bomo o tem tudi posebej obvestili.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Kontaktirajte nas</h2>
                  <p className="text-stone-600">
                    Če imate kakršna koli vprašanja glede naše politike varstva osebnih podatkov ali če želite uveljavljati svoje pravice 
                    v zvezi z vašimi osebnimi podatki, nas lahko kontaktirate na <a href="mailto:info@kamen.si" className="text-primary hover:underline">info@kamen.si</a>.
                  </p>
                </section>
                
                <p className="text-stone-500 text-sm italic mt-8">
                  Zadnja posodobitev: Januar 2025
                </p>
              </div>
            </ScrollArea>
          </motion.div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default GDPR;